import React from "react";
import { Outlet, Navigate } from 'react-router-dom';
import { puedeAdministrarUsuarios, tieneModulo, getRutaModuloMasCercano } from 'utils/permissions';

// Igual que ProtectedRoute (exige sesión), pero además bloquea la navegación
// directa por URL a una ruta con adminOnly o moduloClave si el usuario no
// cumple. Esto es lo que de verdad protege una ruta — el Sidebar solo oculta
// el enlace del menú, no impide escribir la URL directamente.
//
// adminOnly hoy solo lo usa Configuración > Usuarios, así que aquí significa
// "cualquiera de los tres niveles de administrador" (global, regional, de
// departamento), no exclusivamente el admin global.
export const ModuleProtectedRoute = ({
  adminOnly,
  moduloClave,
}: {
  adminOnly?: boolean;
  moduloClave?: string;
}) => {
  const user = sessionStorage.getItem('user');
  const bloqueado = !!((adminOnly && !puedeAdministrarUsuarios()) || (moduloClave && !tieneModulo(moduloClave)));

  // Si la ruta bloqueada era el dashboard (o cualquier otra), no tiene caso
  // mandarlo siempre a "/admin/dashboards" — si tampoco tiene ese módulo,
  // llegaría a una página vacía. En vez de eso, buscamos el módulo permitido
  // más cercano (por el orden de tbaModulos) y lo mandamos ahí.
  const [destino, setDestino] = React.useState<string | null | 'cargando' | 'sin-acceso'>(null);

  React.useEffect(() => {
    if (!user || !bloqueado) return;
    setDestino('cargando');
    getRutaModuloMasCercano().then((ruta) => setDestino(ruta ?? 'sin-acceso'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, bloqueado, adminOnly, moduloClave]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (bloqueado) {
    // Sin destino todavía (resolviendo el módulo más cercano): no renderizar
    // nada un instante, en vez de parpadear hacia /admin/dashboards.
    if (destino === null || destino === 'cargando') return null;
    // Caso extremo: no tiene acceso a ningún módulo. No lo mandamos a
    // /admin/dashboards de todos modos — volveríamos a caer aquí en bucle.
    if (destino === 'sin-acceso') {
      return (
        <div style={{ padding: '2rem', textAlign: 'center', color: '#718096' }}>
          No tienes acceso a ningún módulo. Contacta a tu administrador.
        </div>
      );
    }
    return <Navigate to={destino} replace />;
  }

  return <Outlet />;
};
